module.exports = __webpack_public_path__ + "images/places/export_2923-82511d131b6e36fdd37b48d74a9b90c8.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./web/images/places/export_2923.jpg
 ** module id = 299
 ** module chunks = 0
 **/